import { render, staticRenderFns } from "./WorkflowButtons.vue?vue&type=template&id=c6059d3a&scoped=true"
import script from "./WorkflowButtons.vue?vue&type=script&lang=js"
export * from "./WorkflowButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6059d3a",
  null
  
)

export default component.exports